<template>
  <v-container fluid>
    <v-card-title>Energy Prices</v-card-title>
    <v-card-text>
      <v-textarea v-model="computedValue" outlined></v-textarea>
    </v-card-text>
  </v-container>
</template>

<script>
export default {
  name: "SettingsEnergyPrices",
  components: {},
  mixins: [],
  props: {
    value: { type: Object, required: false, default: () => ({}) },
  },
  data() {
    return {};
  },
  computed: {
    computedValue: {
      get() {
        return this.value.text;
      },
      set(v) {
        this.$emit("input", { text: v });
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
